
export default {
  name: 'AppTab',
  props: {
    tabNames: { type: Array, default: () => [] },
    activeTabIndex: { type: Number, default: 0 },
    isMobile: { type: Boolean, default: false },
    isTabVisible: { type: Boolean, default: true }
  },
  data: () => ({ showLeftArrow: false, showRightArrow: false }),
  watch: {
    activeTabIndex() {
      this.focusOnMenu();
      this.$nextTick(() => this.moveBorder());
    }
  },
  mounted() {
    this.moveBorder();
    this.setArrorState();
    this.$refs.tab.addEventListener('scroll', this.setArrorState);
  },
  methods: {
    moveBorder() {
      if (!this.isTabVisible) return;

      const menuTextElement = this.$refs.menuText[this.activeTabIndex];
      const border = this.$refs.border;
      border.style.left = `${menuTextElement.offsetLeft}px`;
      border.style.width = `${menuTextElement.clientWidth}px`;
    },
    setArrorState() {
      if (this.isMobile) return;
      const tabElement = this.$refs.tab;
      if (
        tabElement.scrollWidth + tabElement.scrollLeft ===
        tabElement.clientWidth
      )
        return;

      if (tabElement.scrollLeft !== 0) this.showLeftArrow = true;
      else this.showLeftArrow = false;

      if (
        tabElement.clientWidth + tabElement.scrollLeft <
        tabElement.scrollWidth
      )
        this.showRightArrow = true;
      else this.showRightArrow = false;
    },
    scroll(direction) {
      const tabElement = this.$refs.tab;
      const stride =
        (tabElement.clientWidth / 2) * (direction === 'left' ? -1 : 1);
      tabElement.scrollLeft = tabElement.scrollLeft + stride;
    },
    focusOnMenu() {
      const tabElement = this.$refs.tab;
      const menuElement = this.$refs.menuText[this.activeTabIndex];
      tabElement.scrollLeft =
        menuElement.offsetLeft - tabElement.clientWidth / 2;
    }
  }
};
